import { ALL_ANNOTATIONS, FILTERING_ANNOTATIONS } from '@readcloud/common';
import { Button } from '@readcloud/component-library';
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from '@readcloud/component-library/components/Base/Modal';
import { User } from '@readcloud/data';

export const ConfirmDrawing = ({
  openDialog,
  setOpen,
  setFilter,
  annoFilter,
  confirmAction,
  currentAuthor,
  filterUsers,
  knownUsers,
  setUserFilter,
  filterAnnotationBy,
}: {
  openDialog: boolean;
  setOpen: (isOpen: boolean) => void;
  setFilter: (annoFilter: string) => void;
  annoFilter: string;
  confirmAction?: () => void;
  currentAuthor: string;
  filterUsers?: string[];
  knownUsers: User[];
  setUserFilter: (users: string[]) => void;
  filterAnnotationBy: (filter: string, users: string[]) => void;
}) => {
  return (
    <Modal isOpen={openDialog} toggle={() => setOpen(false)}>
      <ModalHeader>
        <ModalTitle>Update viewing preferences</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <p>
          You currently have an Annotations Filter applied. Clicking ‘Confirm’
          will reset your filter settings.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button
          variant="ghost"
          onClick={() => {
            setOpen(false);
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            let newFilter = annoFilter;

            //add current user
            const newUserFilter = filterUsers ? [...filterUsers] : [];
            if (!newUserFilter.includes(currentAuthor)) {
              newUserFilter.push(currentAuthor);
            }

            //if we are now displaying all users, we want to have "All Annotations" set.
            if (newUserFilter.length === knownUsers?.length) {
              newFilter =
                ALL_ANNOTATIONS +
                '|Path|Rectangle|OverlayText|Circle|HTML|Media|Image|Text';
            } else {
              //otherwise continue showing "Filtering Annotations"
              newFilter =
                FILTERING_ANNOTATIONS +
                '|Path|Rectangle|OverlayText|Circle|HTML|Media|Image|Text';
            }

            setFilter(newFilter);
            setUserFilter(newUserFilter);
            filterAnnotationBy(newFilter, newUserFilter);
            confirmAction && confirmAction();
            setOpen(false);
          }}
        >
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  );
};
